<template>
  <div class="w-full">
    <Panel header="Tải hình ảnh">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <section class="md:col-span-12">
          <div
            class="rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
              class="mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-3"
            >
              <div>
                <label class="m-0 text-[15px] font-bold text-slate-900"
                  >Tập tin hình ảnh</label
                >
                <div class="mt-1 text-[13px] font-medium text-slate-500">
                  JPG, JPEG, PNG
                </div>
              </div>
              <div class="flex flex-wrap gap-2 text-[13px]">
                <div
                  class="inline-flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-slate-700"
                >
                  <span>Khung ảnh chính</span>
                  <strong class="whitespace-nowrap text-slate-950"
                    >360 x 232 px</strong
                  >
                </div>
                <div
                  class="inline-flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-slate-700"
                >
                  <span>Ảnh thành phần</span>
                  <strong class="whitespace-nowrap text-slate-950"
                    >50 x 50 px</strong
                  >
                </div>
              </div>
            </div>

            <div
              class="grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto]"
            >
              <div
                class="flex min-w-0 items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5"
              >
                <span
                  class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700"
                >
                  <i class="pi pi-image"></i>
                </span>
                <div class="min-w-0">
                  <div
                    class="truncate text-[15px] font-semibold text-slate-900"
                  >
                    {{
                      listFileName.length > 0
                        ? `Đã chọn ${listFileName.length} tập tin`
                        : "Chưa chọn tập tin"
                    }}
                  </div>
                  <div class="text-sm text-slate-500">
                    Có thể chọn nhiều tập tin cùng lúc
                  </div>
                </div>
              </div>

              <div class="flex shrink-0 flex-wrap gap-2 lg:justify-end">
                <Button
                  outlined
                  label="Đính kèm tập tin"
                  icon="pi pi-paperclip"
                  @click="triggerFilePicker"
                  :disabled="loadingBar"
                />
                <Button
                  label="Đăng hình"
                  icon="pi pi-cloud-upload"
                  @click="upload()"
                  :loading="loadingBar"
                  :disabled="loadingBar || listFileName.length < 1"
                />
              </div>
            </div>
          </div>

          <form enctype="multipart/form-data">
            <input
              ref="fileInputEl"
              id="myFile"
              type="file"
              class="hidden"
              accept=".jpeg,.png,.jpg"
              name="files"
              multiple="multiple"
              v-on:change="fileChange($event.target.files)"
              :disabled="loadingBar"
            />
          </form>
        </section>

        <section class="md:col-span-12">
          <div
            class="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
              class="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-3"
            >
              <div>
                <div class="text-[15px] font-bold text-slate-900">
                  Tập tin đã chọn
                </div>
                <div class="text-[13px] font-medium text-slate-500">
                  Kiểm tra danh sách trước khi đăng hình.
                </div>
              </div>
            </div>

            <div v-if="listFileName.length > 0" class="overflow-x-auto">
              <table class="min-w-full divide-y divide-slate-200 text-[15px]">
                <thead
                  class="bg-slate-100 text-left text-xs font-bold uppercase text-slate-600"
                >
                  <tr>
                    <th class="px-4 py-3">Tập tin</th>
                    <th class="w-36 px-4 py-3">Dung lượng</th>
                    <th class="w-28 px-4 py-3 text-right">Thao tác</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-slate-100 bg-white">
                  <tr
                    v-for="file in listFileName"
                    :key="file.nameFile"
                    class="transition hover:bg-teal-50/40"
                  >
                    <td class="px-4 py-3">
                      <div class="flex min-w-0 items-center gap-3">
                        <span
                          class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700"
                        >
                          <i class="pi pi-image"></i>
                        </span>
                        <span class="min-w-0 truncate text-slate-900">{{
                          file.nameFile
                        }}</span>
                      </div>
                    </td>
                    <td class="px-4 py-3 text-slate-600">
                      {{ formatFileSize(file.value?.size) }}
                    </td>
                    <td class="px-4 py-3 text-right">
                      <Button
                        severity="danger"
                        label="Xóa"
                        icon="pi pi-trash"
                        @click="deleteFile(file.nameFile)"
                        class="!min-h-[36px] px-3 py-1.5"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="px-4 py-8 text-center">
              <span
                class="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100 text-slate-400"
              >
                <i class="pi pi-folder-open"></i>
              </span>
              <p class="mt-3 text-sm font-semibold text-slate-600">
                Chưa có tập tin nào được chọn.
              </p>
            </div>
          </div>
        </section>
      </div>
    </Panel>

    <Dialog header="Tải hình" v-model:visible="loadingBar">
      <div id="loading">
        <label>Đang tải hình lên máy chủ ...</label>
        <ProgressBar mode="indeterminate" class="h-[0.3em]" />
      </div>
    </Dialog>
    <ConfirmDialog></ConfirmDialog>

    <!-- Confirm Delete Modal -->
    <ConfirmDeleteModal
      v-model="showConfirmModal"
      :title="confirmTitle"
      :message="confirmMessage"
      :is-loading="isConfirming"
      @confirm="confirmDelete.confirm"
      @cancel="confirmDelete.cancel"
    />
  </div>
</template>

<script lang="ts">
import { ref } from "vue";
import ZaloRepository from "@/services/ZaloRepository";
import { ListImage } from "@/models/listImage";
import { useToast } from "@/ui/services/toast";
import axios from "axios";
import { FileDetail } from "@/models/fileDetail.models";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import { useConfirmDelete } from "@/composables/useConfirmDelete";

export default {
  components: {
    ConfirmDeleteModal,
  },
  props: {
    id: String,
  },
  setup() {
    const products = ref([] as ListImage[]);
    const layout = ref("grid");
    const toast = useToast();
    const show = ref(false);
    const store = useStore();
    const router = useRouter();
    const fileInputEl = ref<HTMLInputElement | null>(null);

    // Use confirm delete composable
    const confirmDelete = useConfirmDelete();
    const showConfirmModal = confirmDelete.isOpen;
    const confirmTitle = confirmDelete.title;
    const confirmMessage = confirmDelete.message;
    const isConfirming = confirmDelete.isLoading;

    if (!store.state.token) {
      router.push({
        name: "home",
      });
    }

    const getListImage = () => {
      ZaloRepository.getListImage()
        .then((response) => {
          products.value = response.data;
        })
        .catch(() => {
          // Keep page usable if the existing image list cannot be loaded.
        });
    };

    const listLink = ref([] as string[]);
    const listFileName = ref([] as FileDetail[]);
    const loadingBar = ref(false);

    const deleteFile = (name: string) => {
      confirmDelete.open({
        title: "Xác nhận xoá",
        message: `Bạn có chắc chắn muốn xoá file ${name}?`,
        onConfirm: async () => {
          const index = listFileName.value.findIndex((x) => x.nameFile === name);
          if (index >= 0) listFileName.value.splice(index, 1);
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xoá file thành công",
            life: 2000,
          });
        },
      });
    };

    getListImage();

    const fileChange = (fileList: FileList) => {
      for (let i = 0; i < fileList.length; i++) {
        const filetemp = ref({} as FileDetail);
        filetemp.value.nameFile = fileList[i].name;
        filetemp.value.value = fileList[i];
        listFileName.value.push(filetemp.value);
      }
    };

    const triggerFilePicker = () => {
      fileInputEl.value?.click();
    };

    const formatFileSize = (size?: number) => {
      if (!size) return "";
      if (size < 1024) return `${size} B`;
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
      return `${(size / 1024 / 1024).toFixed(1)} MB`;
    };

    const upload = () => {
      listLink.value = [];
      const files = new FormData();
      listFileName.value.forEach((x) => {
        files.append("formFiles", x.value, x.nameFile);
      });
      loadingBar.value = true;
      axios
        .post(`/api/file/Upload`, files, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          loadingBar.value = false;
          listFileName.value = [];
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Tải ảnh lên thành công",
            life: 2000,
          });
        })
        .catch((err) => {
          loadingBar.value = false;
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Tải ảnh không thành công",
            life: 2500,
          });
        });
    };

    const imageClick = () => {
      show.value = false;
    };

    const showListImage = () => {
      show.value = true;
    };

    return {
      products,
      layout,
      upload,
      loadingBar,
      listFileName,
      fileChange,
      imageClick,
      show,
      showListImage,
      deleteFile,
      triggerFilePicker,
      fileInputEl,
      formatFileSize,
      // Confirm delete modal
      showConfirmModal,
      confirmTitle,
      confirmMessage,
      isConfirming,
      confirmDelete,
    };
  },
};
</script>
